import React, { useState } from "react";
import styled from 'styled-components';
import axios from 'axios';
import ModalAlert from "./ModalAlert";
import { useTranslation } from "react-i18next";

const FeedbackContainer = styled.div`
    margin: 1.2rem 1.5rem 0;
    padding: 1.4rem;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 16px;
    backdrop-filter: blur(8px);
    display: flex;
    flex-direction: column;
`;

const FeedbackHeader = styled.h3`
    font-size: 0.85rem;
    font-weight: 600;
    color: #c7d2fe;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
`;

const FeedbackDescription = styled.p`
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.45);
    margin-bottom: 1rem;
    line-height: 1.5;
`;

const FeedbackTextarea = styled.textarea`
    width: 100%;
    padding: 0.7rem 1rem;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    font-family: 'Poppins', sans-serif;
    resize: vertical;
    min-height: 80px;
    transition: border-color 0.2s, background 0.2s;

    &::placeholder { color: rgba(255, 255, 255, 0.25); }
    &:focus {
        outline: none;
        border-color: rgba(99, 102, 241, 0.5);
        background: rgba(255, 255, 255, 0.08);
    }
`;

const FeedbackButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    padding: 0.6rem 1.5rem;
    margin-top: 0.8rem;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: white;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 3px 14px rgba(99, 102, 241, 0.3);

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 5px 20px rgba(99, 102, 241, 0.45);
    }
    &:active { transform: translateY(0); }
`;

const FeedbackForm = () => {
    const [feedback, setFeedback] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', message: '', isSuccess: false });
    const { t } = useTranslation();

    const handleFeedbackSubmit = async () => {
        try {
            if (!feedback) return;
            await axios.post(`${process.env.REACT_APP_SERVER}/feedback`, { feedback }, { withCredentials: true });
            setModalContent({ title: `${t('SuccessTitle')}`, message: `${t('FeedbackUpdatedSuccess')}`, isSuccess: true });
            setFeedback("");
        } catch (error) {
            setModalContent({ title: 'Failed', message: 'Feedback submission failed. Please try again.', isSuccess: false });
        }
        setIsModalOpen(true);
    };

    return (
        <>
            <FeedbackContainer>
                <FeedbackHeader>{t('AccountFeedbackTitle')}</FeedbackHeader>
                <FeedbackDescription>{t('AccountFeedbackText')}</FeedbackDescription>
                <FeedbackTextarea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    maxLength="500"
                    placeholder={t('AccountFeedbackTextArea')}
                />
                <FeedbackButton onClick={handleFeedbackSubmit}>
                    {t('SubmitFeedbackButton')}
                </FeedbackButton>
            </FeedbackContainer>

            <ModalAlert
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={modalContent.title}
                message={modalContent.message}
                isSuccess={modalContent.isSuccess}
            />
        </>
    );
};

export default FeedbackForm;
